import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';
import {ProspectRequest} from '../models/request/prospect/prospect-request';
import {Constant} from '../common/constant';
import {District} from '../models/response/address/district';
import {DistrictRequest} from '../models/request/address/district-request';
import { DistrictOfficeRequest } from '../models/request/address/district-office-request';
import { CityRequest } from '../models/request/address/city-request';

@Injectable()
export class SuburbService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(suburbId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.SUBURB +
      Path.SUBURB_ID.replace(':suburbId', suburbId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SUBURB +
      Path.SEARCH, request,
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  create(request: ProspectRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SUBURB, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  remove(suburbId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.SUBURB +
      Path.SUBURB_ID.replace(':suburbId', suburbId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  update(request: ProspectRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.SUBURB, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  updateList(requests: DistrictRequest[]): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.SUBURB + Path.LIST, requests).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  // ===== support for autocomplete ============
  searchByKeyword(keyword: string): Observable<District[]> {
    const searchRequest = new SearchRequest();
    searchRequest.conditions = new Array();
    searchRequest.conditions.push(
      {
        left: 'name',
        middle: 'like',
        right: keyword,
      },
    );
    searchRequest.conditions.push(
      {
        left: 'code',
        middle: '=',
        right: keyword,
      },
    );
    searchRequest.conditionType = Constant.CONDITION_TYPE.OR;
    searchRequest.offset = 0;
    searchRequest.limit = 10;
    return this.search(searchRequest).pipe(
      map(result => result.data),
    );
  }

  createOrDeleteDistrictOffice(request: DistrictOfficeRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SUBURB + Path.ASSIGN, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  fetchDistrictBySelectedOffice(officeId: number): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SUBURB + Path.ASSIGNED, officeId).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  fetchByParentId(request: CityRequest[]): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SUBURB +
      Path.PARENT, request,
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }
}
